import { memo, useEffect, useRef } from 'react'

import { useQuery } from '@tanstack/react-query'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'

import { Editor, EditorInstance } from '@shared/components/Editor'
import { LoadingIndicator, NotFound } from '@shared/layouts'
import { useVideoStreamUpdateMutation } from 'hooks/mutations/content'
import { videoStreamConfigRoute } from 'pages/NWPlatform/Workspaces/Workspace/Video/Streams/Stream'
import { videoStreamQueryKeys } from 'services/queryKeys'

const JSONRaw = () => {
  const { t } = useTranslation(['domain'])
  const { enqueueSnackbar } = useSnackbar()

  const editorInstanceRef = useRef<EditorInstance>(undefined)

  const { videostreamId: streamId } = videoStreamConfigRoute.useParams()

  const videoStreamQuery = useQuery(videoStreamQueryKeys.detail({ streamId }))
  const { data: videoStream } = videoStreamQuery

  const { mutate } = useVideoStreamUpdateMutation()

  useEffect(() => {
    if (editorInstanceRef.current && videoStreamQuery.isSuccess) {
      editorInstanceRef.current.getModel()?.setValue(window.JSON.stringify(videoStream, null, 4))
    }
  }, [videoStreamQuery, videoStream])

  if (videoStreamQuery.isLoading) {
    return <LoadingIndicator />
  }

  if (!videoStream) {
    return <NotFound />
  }

  return (
    <Editor
      value={videoStream}
      onSubmit={(data) => {
        mutate(
          {
            streamId,
            videoStreamEdit: data,
          },
          {
            onSuccess: () => {
              enqueueSnackbar(t('domain:Workspace.Video.videoStreamSaved'), {
                variant: 'success',
              })
            },
          },
        )
      }}
      getEditorInstance={(editorInstance: EditorInstance) => void (editorInstanceRef.current = editorInstance)}
    />
  )
}

export const JSON = memo(JSONRaw)
